import { Box, Divider, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import Section from "../../../Component/Layout/Section";
import { getSearchResult } from '../../../service';

type Props = {
  params: any;
  postType: string;
  title: string;
  isSingle: boolean;
};

function SearchSection({ params, postType, title, isSingle }: Props) {

  const { isLoading, data } = useQuery(['search', params.keyword, postType], () => getSearchResult(params.keyword, postType));

  const Item = ({ title, excerpt, permalink }: any) => {
    return (
      <Box maxW="1200px" w="100%" pb={4}>
        <Link href={permalink}>
          <Heading size="lg" dangerouslySetInnerHTML={ {__html: title} } pb={1}/>
          <Text fontSize="sm" color="b.g" noOfLines={2}>{excerpt}</Text>
        </Link>
      </Box>
    ) 
  };

  return (
    <>
      <Section pt={1} pb={40}>
        <Heading as="h1" size="3xl" color="b.dgr" pb={2} >
          {title}
        </Heading>
        { !isLoading && data && data.items.length > 0 && (
        <Box pt={4} pb={4}>
          <Stack>
            {
              data.items.map((item:any, index:number) => (
                <Item key={index} {...item} />
              ))
            }
          </Stack>
        </Box>
        )}
        {!isLoading && data && data.items.length === 0 && (
          <Box pt={4} pb={4}>
            <Text fontSize="md" color="b.g">
              검색 결과가 없습니다.
            </Text>
          </Box>
        )}
        {
          !isSingle && (
            <>
            <Divider color="b.lg" variant="dashed" />
            <Box textAlign="center" pt={2}>
              <Link href={`/search?keyword=${params.keyword}&postType=${postType}`}><Text fontSize="md">더보기</Text></Link>
            </Box>
            </>
          )
        }
      </Section>
    </>
  );
}

SearchSection.defaultProps = {
};

export default SearchSection;
